<template>
    <div class="app-bar-wrap">
        <div class="operator-company" v-if="userCreds.isOperator == 'True'">
            <span>{{ user.companyName }}</span>
        </div>
        <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
            <v-btn class="mr-2" icon plain small @click="$emit('update:drawer', !drawer)" style="margin-left: -8px">
                <v-icon v-if="!drawer"> mdi-menu </v-icon>
                <v-icon v-else> mdi-menu-open </v-icon>
            </v-btn>
            <v-toolbar-title class="hidden-sm-and-down font-weight-light" v-text="$route.name" />
            <v-spacer />

            <template v-if="userCreds.isOperator != 'True'">
                <v-alert v-if="needsUpdateSubscription" class="mt-6 py-2" border="left" type="error">
                    <v-row align="center">
                        <v-col class="pt-2">
                            Missing subscription. Go to the Billing page to begin your subscription.
                        </v-col>
                        <v-col class="pb-2 shrink">
                            <v-btn outlined color="white" @click="toBilling">Proceed to Billing</v-btn>
                        </v-col>
                    </v-row>
                </v-alert>

                <v-alert v-else-if="expired && !needsUpdateSubscription" class="mt-6 py-2" border="left" type="error">
                    <v-row align="center">
                        <v-col class="pt-2"> Subscription has expired. Please restart subscription. </v-col>
                        <v-col class="pb-2 shrink">
                            <v-btn outlined color="white" @click="toBilling">Proceed to Billing</v-btn>
                        </v-col>
                    </v-row>
                </v-alert>

                <v-alert
                    v-else-if="noDefaultPaymentMethod || needsUpdateSubscription"
                    class="mt-6 py-2"
                    border="left"
                    type="error"
                >
                    <v-row align="center">
                        <v-col class="pt-2">
                            Missing payment method. Go to the Billing page to add a payment method.
                        </v-col>
                        <v-col class="pb-2 shrink">
                            <v-btn class="font-weight-bold" outlined color="white" @click="toBilling"
                                >Proceed to Billing</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-alert>

                <v-alert
                    v-else-if="paymentActionRequired || needsUpdateSubscription"
                    dense
                    class="mb-0 py-0"
                    border="left"
                    type="error"
                >
                    <span class="text-h4">
                        Payment failed. Go to the Billing page to update payment information.
                        <v-btn outlined color="white" @click="toBilling">Proceed to Billing</v-btn>
                    </span>
                </v-alert>

                <v-alert v-else-if="corruptSubscription" dense class="mb-0 py-0" border="left" type="error">
                    <span class="text-h4">
                        Subscription details missing. Go to the Billing page to update your subscription.
                        <v-btn outlined color="white" @click="toBilling">Proceed to Billing</v-btn>
                    </span>
                </v-alert>
            </template>

            <div class="mx-3" />

            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="$emit('toggle-help')" v-bind="attrs" v-on="on" class="text-capitalize">
                        <v-icon left>mdi-help-circle-outline</v-icon>
                        <span>Help</span>
                    </v-btn>
                </template>
                <span>Help Center & Chat</span>
            </v-tooltip>

            <div class="mx-4" />

            <v-menu offset-y v-model="showMenu" :close-on-content-click="false" v-if="user">
                <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-flex align-center" style="cursor: pointer">
                        <div class="mr-2 font-weight-light">
                            {{ user.email }}
                        </div>
                        <account-user-avatar class="ml-0" :user="user" :size="40"></account-user-avatar>
                    </div>
                </template>

                <v-card outlined class="my-0">
                    <v-list max-width="300">
                        <v-list-item>
                            <v-list-item-avatar>
                                <account-user-avatar class="ml-0" :user="user" :size="40"></account-user-avatar>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ user.firstName }} {{ user.lastName }}</v-list-item-title>
                                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list>
                        <v-toolbar flat height="72" class="py-4 pl-2 mt-0 transparent">
                            <v-switch v-if="settings" :input-value="$vuetify.theme.dark" @click="toggleDarkMode">
                                <template v-slot:label>
                                    <span class="pl-3 text--primary">Dark Mode</span>
                                </template>
                            </v-switch>
                        </v-toolbar>

                        <v-toolbar flat height="72" class="pb-4 pl-2 mt-1 transparent">
                            <!-- <v-switch
                            v-if="settings"
                            :input-value="settings.timeFormat24Hour"
                            @click="toggleTimeFormat"
                            hint="24-hour"
                            persistent-hint
                        >
                            <template v-slot:label>
                                <span class="pl-3 text--primary">24 Hour Time</span>
                            </template>
                        </v-switch>
                    </v-toolbar>
                    <v-toolbar flat height="72" class="pb-4 pl-2 mt-1 transparent">
                        <v-switch
                            v-if="settings"
                            :input-value="settings.timeFormatShowSeconds"
                            @click="toggleTimeFormatShowSeconds"
                            hint="seconds"
                            persistent-hint
                        >
                            <template v-slot:label>
                                <span class="pl-3 text--primary">Show Seconds</span>
                            </template>
                        </v-switch> -->
                            <time-zone-picker />
                        </v-toolbar>
                        <v-divider class="mt-2" />
                        <v-toolbar flat height="72" class="pb-4 mt-1 d-none"> </v-toolbar>
                    </v-list>
                    <v-btn
                        @click="showMenu = false"
                        to="/account"
                        text
                        block
                        plain
                        large
                        class="rounded-0"
                        style="padding-left: 32px !important"
                    >
                        <v-icon>mdi-account</v-icon>
                        <span class="ml-7">Account Settings</span><v-spacer />
                    </v-btn>
                    <v-btn
                        @click="logout"
                        text
                        block
                        plain
                        large
                        class="rounded-0"
                        style="padding-left: 32px !important"
                    >
                        <v-icon>mdi-logout</v-icon>
                        <span class="ml-7">Log Out</span><v-spacer />
                    </v-btn>
                    <v-divider class="mt-2" />
                    <v-btn
                        class="mt-2 rounded-0"
                        plain
                        block
                        large
                        style="padding-left: 32px !important"
                        :width="$vuetify.breakpoint.smAndUp ? '' : '100%'"
                        to="/help"
                    >
                        <v-icon>mdi-help-circle-outline</v-icon>
                        <span class="ml-7">Help</span><v-spacer />
                    </v-btn>
                </v-card>
            </v-menu>
        </v-app-bar>
    </div>
</template>

<style lang="scss">
.app-bar-wrap {
    .alert-hover:hover {
        text-decoration: underline;
        text-underline-offset: 3px;
        text-decoration-thickness: 2px;
        cursor: pointer;
    }
    .operator-company {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1000;
        background-color: rgba(255, 255, 255, 0.1);
        padding: 3px 12px;
        border-radius: 0 0 5px 5px;
        font-size: 12px;
    }
}
</style>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import UpdatesModal from "@cmp/updates/UpdatesModal";
import TimeZonePicker from "@cmp/base/TimeZonePicker";
import AccountUserAvatar from "@cmp/base/AccountUserAvatar";

export default {
    name: "DashboardCoreAppBar",

    components: {
        UpdatesModal,
        TimeZonePicker,
        AccountUserAvatar,
    },

    computed: {
        ...mapGetters("settings", ["settings"]),
        ...mapGetters("user", ["user", "userCreds"]),
        ...mapGetters("heartbeat", [
            "needsUpdateSubscription",
            "noDefaultPaymentMethod",
            "paymentActionRequired",
            "corruptSubscription",
            "internal",
            "external",
            "expired",
        ]),
    },

    props: ["drawer", "help"],

    data: () => ({
        showMenu: false,
        updatesModalForceShow: false,
        updatesModalUnseen: true,
    }),

    methods: {
        ...mapActions("user", ["logout"]),
        ...mapMutations("settings", ["toggleDarkMode", "toggleTimeFormat", "toggleTimeFormatShowSeconds"]),
        toBilling() {
            if (this.$route.path !== "/billing") this.$router.push("/billing");
        },
        handlehelp() {
            this.$emit("help", !this.help);
        },
    },
};
</script>
